import sha512 from "./crypto/sha512";
import rsa from "./crypto/rsa";



export function encriptarRsa(tramaEntrada) {
  var rsa_ = new rsa();
  rsa_.setPublicCert(PublicKeyWeb);
  var tramaEncriptada = rsa_.encrypt_b64(tramaEntrada);
  return tramaEncriptada;
}

export function encriptarContrasenia(contrasenia) {
  return sha512.sha512(contrasenia);
}

export const desencriptarRsa = trama => {
  try {
    var rsa_ = new rsa();
    rsa_.setPrivateCert(PrivateKeyMiddleware);
    //rsa_.setPrivateCert(privateKey2);
    return rsa_.decrypt(trama);
  } catch (error) {
    return "error";
  }
};

export function desencriptarTramaAES(tramaEntrada, key, iv) {
  try {
    let llave = desencriptarRsa(key);
    let cuatro = desencriptarRsa(iv);
    llave = llave.replace(new RegExp('"', "g"), "");
    cuatro = cuatro.replace(new RegExp('"', "g"), "");
    var noencriptado = decryptAES(tramaEntrada, llave, cuatro);
  } catch (error) {
    console.log('')
  }

  return JSON.parse(noencriptado);
}

function decryptAES(data, key, iv) {
  var crypto = require("crypto");
  var decipher = crypto.createDecipheriv("aes-256-cbc", key, iv),
    buffer = Buffer.concat([
      decipher.update(Buffer.from(data, "base64")),
      decipher.final()
    ]);
  return buffer.toString();
}


function makellaves(length) {
  var result = '';
  var characters = '0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

// /************* */
export function encriptarTramaAES(tramaEntrada) {
  try {
    let key = makellaves(32)
    let iv = makellaves(16)
    var trama = encryptAES(tramaEntrada, key, iv);
    key = encriptarRsa(key)
    iv = encriptarRsa(iv)
    return { trama, iv, key };
  } catch (error) {
    console.log(error);
  }
}


function encryptAES(text, key, iv) {
  var crypto = require("crypto");
  var alg = "aes-256-cbc";
  key = new Buffer(key);
  iv = new Buffer(iv);
  var cipher = crypto.createCipheriv(alg, key, iv);
  var encoded = cipher.update(text, "ascii", "base64");
  encoded += cipher.final("base64");
  return encoded;
}
// /**********************  */

// export function encriptarRsa2(tramaEntrada) {
//   var rsa_ = new rsa();
//   rsa_.setPublicCert(PublicKeyWeb);
//   var tramaEncriptada = rsa_.encrypt_b64(tramaEntrada);
//   return tramaEncriptada;
// }

// export const desencriptarRsa2 = trama => {
//   try {
//     var rsa_ = new rsa();
//     rsa_.setPrivateCert(PrivateKeyMiddleware);
//     //rsa_.setPrivateCert(privateKey2);
//     return rsa_.decrypt(trama);
//   } catch (error) {
//     return "error";
//   }
// };


// //desencriptar en Reackt // Desencriptar React
const PrivateKeyMiddleware = "-----BEGIN RSA PRIVATE KEY-----" +
  "MIIJKAIBAAKCAgEAixHN48rsYHwNUGId2GB3jfPl/fZnbAPKXPQiFdxxksBeedeN" +
  "sJ8PCxNuEXF/L6euOz/4Ibecj4YPm0F+k2IW9n82wn2bIpJVgzW1d5zo6y8jZLEs" +
  "P02lH9KcO8XpQhg+U7DSxCjIeBx8ivr0uFrc6zM0eFbCNWL+vJJ9AMMMCI/hLAVy" +
  "bPa8Qap90TRfvE1k46GCVlgQcrWKAfX2kidjzmPdNh2f2omd8YDuB8oDsSKOGhlK" +
  "lT/yZEhMWku3LvjNVc1bdJ+kSiaOZiABPTO+8FHNA69L2GCXEah+6n9Lvr4puygN" +
  "+MDeqGvKBw72OsPqjtAQFmjrjNr9iXkjNEZGfF1oiHoBVuQZqnI7zZh/3TbqGzwU" +
  "7QYQ8meA+J2qdo19ZkM0ZouNdRMslI7MctxFUuKGsAZM7R8bHk3GXRCx4WFfacB+" +
  "fVVZgeLvhcfbIc0vwbGGQ6TVJ39jl/qmAZ3nYif0Ptftlss7my+Gr5WHYiVWbY5y" +
  "Sa2fT1EVnzdFAmHqPBuPfFzTJriEear3Gnzz15vqHpcon3UD/Kn4NKzAHEtoaaw2" +
  "x+Ch7fSN/NMTdd4E5XVQwzMwfgj0LgDzgzqHnWGH9AXhoQRDrWb5BH+7fGdqIPRh" +
  "uaWqLih8eyZ+8kmxJsOGKkhLC7FlVxwAYkXSvPNaBgJSgxcg3mSxuhjxATECAwEA" +
  "AQKCAgBv/8q85bQwkDd4wUwf8rDWFdLoEQWBrBvReJvq1zpwYZS0s7BcyfynguJm" +
  "Ee3IR1a+SOpg3SqtO95dvwVdVOYBZrqHL/k8gnVz0lFvH2NF5RSwBzAHW1TcqBVC" +
  "3kTZAgVQCVv0tpOch/SVST7FKgg5M2fScqy9qhhVbfRWJL8QNi+18D0THDLI/7GM" +
  "Ro3DbOEPogcB2rKEb0fSBHCrjCWJFkwVRQ50Rdh5osgQZdVLVvTyd+PlBzcDJGa5" +
  "YbkJjz5vF4/MALWjMiIEhUn6LC5eBMMDcK24eTGw+u4blKE/4I5jOALojwvCv+xY" +
  "eug6s4W3tkD+i0kIi2Uczf5YHzCrz7ahRDS9wTad8NIIzdSiJSUBuztLspwsJLVE" +
  "G7K52pDBGkc0DdGLlGB9NDKkuyF6HOuPeYkXp0f1nC3KzXHiEwdhquTAll4UuEIr" +
  "n7N5+zXSwjOlMTUV9Bsj5qlS5sFOD6baISqFB1Orha1YBMIDNdUmRcgQ/DpvOwwV" +
  "0H13uIbe+m/4yeuOrCXOlNy+foVbPtO/RSAM8MTFe5dgqT4mPsIXsbpdLhpqgL/g" +
  "qgjP40OmDTxToH718NmHtC5XaaHcEtH05XzR5ynxAmb0Ka+HkatOqDHqrRZOkPMj" +
  "zIdH/9f/6ItPXZy0is4y4kSHtRYX77q5nVYCsIETb3ST0dWb8QKCAQEAxEx9zlr3" +
  "qN6r9hom0+6IBMoEHNV6Fu8wqZTsGB7L4xjLGZRC1KPcPq+20Wetw8RGX5DYFg49" +
  "14DvcIOQwk5YM2Q4VjQQJFum/VDmNJo+ALzg0JcmrIxnsaSAw4RCHD4Yr0vzfJp1" +
  "XmrpBxcfHi2aMFhewglwOfdQwRHTpZen/aT4+p6N7jlUO4KoCp2E0OO09E8NVZ1s" +
  "zP5N+Elwrr/HGBBGEi1ZGvhWXMhLg6yY2rKTAdGFExXfi2tM8u+h3yB7xvRZqTJl" +
  "fDWo5dl0aYoVeZA+GmjpbdTXtuDQLvQx5ypMgak7PMZbUAeG86lumwDREb5PQAn6" +
  "GzlTwRj4a0+9IwKCAQEAtV2JIj1/nz4GWFsIVmtsPGSLI/8FwPoRXEm24TPyJzBX" +
  "NF9T8O8ZpS/kwn81mF4GBRiW3Hjh/iuXZdRZ+mW2DOUcaXbRtrY15aT314zlW2r0" +
  "Ahk8filSvkc/t202JR26xSvxX5v4xTk3XFR9xce/a9LUyzb5hUt45l+PIZlyQ9aj" +
  "cyFNc0tXVJKPAkCKbEW2kbnY2i1OFfYDv2A1Y8ROxjrUy2c0VUrLZfobqKP8yrry" +
  "ZB6jtOFBz7OjCjjUETm+TgJdxkcDA/2uTYQbdmLUmUlOYDTnlQNSBh3dwtpBY2Zb" +
  "SuhmfodgFK3kuH57aQWBJV0ySWBXIUDJq9eZ0PjfmwKCAQBkW78OG0/3FDDSl7g2" +
  "LgN4f1fu7e2HgC5e5PZ3tncC2hAsObKZSFU371oGYX1jUxuvjDwNuqY/YXoJChqe" +
  "XLOXQqvS1rdR/1G2vP+U8S617dr6ieyJ1xbEqZfzXdD244B3TttjXwyWgw40Q8vy" +
  "/9mO0f9QMMchu6Gbs+ODC7Ala4ynhRyHKOQ5sKj9FF9s9J31Md1dYijX/UQbpmBn" +
  "10CQuvE4JdsigMiWkwiYf0t+tEGYcmgYw9wQSYGDyqP1kYP2ycJ1UIC2KjD5ol1z" +
  "/9bO2cIGepCtSF4o73NALjS9PND0kXLptXfFyLNkK8GSma5J5gRadz9ZX8vEM2H+" +
  "azwFAoIBAQCvolctC3VN1xj5855NYlY83flI8Ky3xvOM9e3ehRmaDdxFYZO+nS2u" +
  "pITaPaq/VT5rLPbbp0zjgX9qI4zHSjxUnIM5NtG8KRRkwa8p1M5AC4Eljx7f5lC0" +
  "5/ayQVbP9sxqKTXkqvzssY4FIeVy5Q9g8ZkU+rYE+aOpJR1NInZfb7p1wehpIKr/" +
  "wbYwLiRe2dwFn357OqiF5+qVKCxL402N9mcgW194wafbp6ulUrl58jTN9EYA4quC" +
  "4qmfOo1T6SF8FhqN6zLmaIKlmqulp+vOTglSbaleywph1gZtrkLoabU7A3hOS/cl" +
  "z4jRidslRylb77bFDEEUeNNUUMQqdPjFAoIBAEjSX4pbACQ+hCs+T/3jS4nH7mvN" +
  "byuvAnW9njQt3hI6uBmlhh62nC7xEYmSKOJAoFEzALBN4n5LnWOlm05zSB77zoRc" +
  "5xWAIfaAbPDiu8wMsQ2ZzIQsu2/ygGq4jCu7RBU3a1D+r4MpbQbyLYoRg9tF4ISB" +
  "5vWWWEcXeXzgLmFfAVPZDcja9fA9S3krgAMEzltVkCt55LhPag/Btu1rkUK4MQbB" +
  "3f6+BnBrWniVteSQmHyvGiFqsXmswUazlWP+SmOEAQgIcVbyXvLkzi3qXUF/HYcV" +
  "urlY29XQPS05ux1Iu/j4Sf0Ohwk9YCaQGYY3KI24l9d8bxgNbR7pAced5sc=" +
  "-----END RSA PRIVATE KEY-----"

// //encriptar en el middleware // Encriptar Middleware -> React
// const PublicKeyMiddleware = "-----BEGIN PUBLIC KEY-----" +
//   "MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAixHN48rsYHwNUGId2GB3" +
//   "jfPl/fZnbAPKXPQiFdxxksBeedeNsJ8PCxNuEXF/L6euOz/4Ibecj4YPm0F+k2IW" +
//   "9n82wn2bIpJVgzW1d5zo6y8jZLEsP02lH9KcO8XpQhg+U7DSxCjIeBx8ivr0uFrc" +
//   "6zM0eFbCNWL+vJJ9AMMMCI/hLAVybPa8Qap90TRfvE1k46GCVlgQcrWKAfX2kidj" +
//   "zmPdNh2f2omd8YDuB8oDsSKOGhlKlT/yZEhMWku3LvjNVc1bdJ+kSiaOZiABPTO+" +
//   "8FHNA69L2GCXEah+6n9Lvr4puygN+MDeqGvKBw72OsPqjtAQFmjrjNr9iXkjNEZG" +
//   "fF1oiHoBVuQZqnI7zZh/3TbqGzwU7QYQ8meA+J2qdo19ZkM0ZouNdRMslI7MctxF" +
//   "UuKGsAZM7R8bHk3GXRCx4WFfacB+fVVZgeLvhcfbIc0vwbGGQ6TVJ39jl/qmAZ3n" +
//   "Yif0Ptftlss7my+Gr5WHYiVWbY5ySa2fT1EVnzdFAmHqPBuPfFzTJriEear3Gnzz" +
//   "15vqHpcon3UD/Kn4NKzAHEtoaaw2x+Ch7fSN/NMTdd4E5XVQwzMwfgj0LgDzgzqH" +
//   "nWGH9AXhoQRDrWb5BH+7fGdqIPRhuaWqLih8eyZ+8kmxJsOGKkhLC7FlVxwAYkXS" +
//   "vPNaBgJSgxcg3mSxuhjxATECAwEAAQ==" +
//   "-----END PUBLIC KEY-----"



// //desencriptar en el middleware // Desencriptar Middleware
// const PrivateKeyWeb = "-----BEGIN RSA PRIVATE KEY-----" +
//   "MIIJKQIBAAKCAgEA8Df40sRBUL+PbE+GJbJG1d1zNPbnkgyg2f3ax1TSxsrKZD6l" +
//   "6IxO7bkdLrGB9e5wYRa8oqIUXEKo7qe9N+dtzaOg0PAmEyDVcLk/iXjlaj73uyjn" +
//   "IQEbh/TcoEk8UnZPmOytg0QnZwWcV+tQG6hVQ2VdEHOSQDLyINs9i5NXvncfx6UP" +
//   "i8SoK7DrLtNeKBPhGfCpc5fLZBuzPvhmUx4JKItdSieUhKhdfkOz3ZkTAfCU64/X" +
//   "keTYxhWi25L06i+cr5CUo4OJ1Ai/fOxTA5O/cR+/akEty697Tw+cGXhnHEzV41fW" +
//   "6v/9NMd5l4KEbjaBFjBaEFuuMOw99ViTX0s/meF64WgEjKxSruGlrwM+3fdKTkPk" +
//   "oVx7YauHH5zGNoozJXit4i4+YkYIvNNY8qbEfH4D3pRyh4n7QyisYaHJapcHr8Jw" +
//   "tZxpjYxm6mNY1d4qCx9aGFJGUcwYRvi8JSW/aiHSrjSBTZ3UKf+rzmHYw8uAnunK" +
//   "JqQKYUvxQSeYd1tXkZyGOwM6PKxpPUtd+vq+I0jVG3HRo1aSBjkrp86ej+Y6/GI7" +
//   "RHR1jfekxMDduJb7Rsol5VdqVHBalIS4Wg6T5n2UKEe60nBj4zXr/6Arc/fI8b7r" +
//   "3dD2STuKdwyYwGKZbzxk/E5BznL79TOLvGC5qnadWKZdWmI+rtvVireF6GkCAwEA" +
//   "AQKCAgB6Wcfech9iZW9Dl22YHal+nIBlZayk8tGqtmWMSWPh5MAZNt+CBpTc+AAp" +
//   "HDg5buzGRrJlk3ATXdB1XfI+Wx3OM51hTi/WZk7QT0pRVsZiyxeauEagxNOk9863" +
//   "xRV4WtJH7aSiyz/WdUEgdrYioCZtYV95VaQUFt7EZWZ/hNiYJkyFf0jfw5Z0SnQ/" +
//   "MWEvwJBSigWE3re1kXZGiHZ1t0Kq5/DoKCi5OJgGC629HI5V2pe/M1B0+r5+hd6h" +
//   "P8SG0yFXOqi6b/DvklUV57iQhdxoXec8013j9Mk1h5nWT0EVZP08Ai1xHFl3XHJN" +
//   "/Sg+inxNNOtqkYezW2Bjam4Fh2ooldPNCirsHAtnXF2hneM+C8+mFpeeDV4Qyx9J" +
//   "0krzvtYJkaLxU4h1LCPFKQ/gPaO8WiMTRCapCM3BEKanTCFGTqf5GZmiVG6hKG/S" +
//   "WIBDYckWTNZhmg8WMem0sIy54vXOsxqLP8d4EuTF98H6asY8GQIH5+1NVPxfPyOW" +
//   "9h57PQkZirBBDZGLe0oSSla4sSq35HJgjRzW0YRLl/ab7v+m0/TDSudE09TosMwg" +
//   "uh1HAYmBsSSdNmm5jpG2vVpnennvBxae53em4g3yLOpwuTTc/cpQbhPOiTuXVZpJ" +
//   "d5yBGUPJZSgicUfTnDMOVJIwJjJkv5LaXOlXFsNp+MobYYMW0QKCAQEA+jOZ8lBj" +
//   "6vJNV2aw3JStHoK4mxVwtOWGExRdzgXARcIOmFkj9ZUoCxAyvWg6aIjv/1JVKoz/" +
//   "GYeVxP8PYxWqvUN6jMmGj6JxZnV6nM3BTxO459ypFQ776Jj2ySEePF9G6dOGVfDH" +
//   "uV/Zr5BLoasVqSGDO4ze9G3iLlhoBfI6WBW8oK9mmDctCen82Zz1Zb1MTqBpyh8u" +
//   "vE4z+1t4IUqot5naoILgjNYAPb82dt/7EWhmYWhQf2NGT9/59HZA+T7v0sUOMPgS" +
//   "bQOmIQT49cs70KUEx7S8YW2fEkyI3J4VWCUA8yI1IdHGBqsj8+XW2j266OpK8Y4E" +
//   "ugqWEbartHLdtwKCAQEA9ckkz2813MZbKTT6Ex3vksL37na+QJoDZ7uECudQbcff" +
//   "I3qq98PxF3hkMXMeK9tz+DWuyMQV/L9QBUkxF6VX2yEhaStnBQowP7ROfQ0+crUT" +
//   "Adx758Z5AZeew2WRorqHtbOkN2JqohAN9FJ3o8wTEUx66vh+DxCzDjyd6WBoLdWV" +
//   "ZE+64XeAy8bHTCq2MNEJarY8SeBBwK3strmrieYgZdnrvKtqegA2h2VgGlWXPvOD" +
//   "5cM1Ox9h33rW0gVhuEcOKHMWDeAe4lxu0WCl4dPqlLleAfNUYd3CLA1AyUHdNwWS" +
//   "/9bEZtwppWp5g96snc9S9nbxPWLsASXTjMQQ1Z9q3wKCAQByk8bgDKh1I1j/uWss" +
//   "2HkfC8X2Xy8p6CIqAp2ih0exqlh8s/WftRqNVnGmA2EcFfmx9sZBoigATPLtL9Cg" +
//   "E4AJBCnO50rT5BQCU7I+tIrd5645n/deSWpa7hG1sZDjHM6grdlK6eTMo3RQzceU" +
//   "1YAp38r1LmG7lcaKarnYX0EQrYOgIjLdagcaDylXjmVinfmf2B4aDYWdfkKXzR+K" +
//   "P2JcEfzonIaweB/MJxCOB6w2IJUh7l9OtuuwEGWq6ax/d67j2pHRIwltGsqtPFW2" +
//   "WceemLNDsSTDiSvbeWkDfvFPWELDFNs4DZSd4Smpu4tUjghWOVTwoZTQjaCDpB+l" +
//   "lySpAoIBAQC+rppcRA8phMncojkQ87yVw6TN4FmhjNrvc07xlpuTT+kRgW16Yw18" +
//   "A+7XXlQd+ldyTVOYdmgIefP+5dWsXp5WZtGg4gc+pbTg92WdJtU38LsaSo/mNNhU" +
//   "H+kP9pCSCtyWXxQb08KekI4C6qfe78grN4Z1HOvPjEkd1nE8SYsJZBZOiHyXxzqo" +
//   "3UJpGQnXvZTssQz803qvnT90U399sIeZ/QMikGo+1EN5r3BrfdOlBw9hBZ0ajTJF" +
//   "Suu2bG5vpNCbGQ4XHbVYMBXZYn3PQbVQRK9mG/1vH7gwrOeCPBL/SNfOnDQrCMtW" +
//   "hdBYOjz5AYt/oq9tzH0ENvB02Pemg9NJAoIBAQDnIMWLU9pblt5zWgtUdMStdyn2" +
//   "wBgJFSnG/Vm8D7FtshDqzrmNbCqfQ0YCxf13kajJE5Iq8pOlOMD2pDhdr6R0o853" +
//   "ATkUtwDCYq2OMQHo5tpMD0ynAyVfv/yUcGcpGsBddLurAsK+5e5cBL+sFoJ5ufTe" +
//   "7Vp2ayFkC57LAmH06lSc2ILD++uunHpO6y7Z4oUgdRw8h+7v2dGkJx0ujw6bdKUp" +
//   "IgtHbHKggQ37JX4gGNwluzsaXZ6VUAvJ3nVHN3+ojkonGCx1DizoSZZgeETMRHyZ" +
//   "o4k3/juvmlMvTIRC72wh425ZTNMP0gX7w4dzJZDQYTGAM8MbQ5VoJz6jl5sb" +
//   "-----END RSA PRIVATE KEY-----"

// //encriptar en react hacia el middleware // Encriptar React -> Middleware
const PublicKeyWeb = "-----BEGIN PUBLIC KEY-----" +
  "MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA8Df40sRBUL+PbE+GJbJG" +
  "1d1zNPbnkgyg2f3ax1TSxsrKZD6l6IxO7bkdLrGB9e5wYRa8oqIUXEKo7qe9N+dt" +
  "zaOg0PAmEyDVcLk/iXjlaj73uyjnIQEbh/TcoEk8UnZPmOytg0QnZwWcV+tQG6hV" +
  "Q2VdEHOSQDLyINs9i5NXvncfx6UPi8SoK7DrLtNeKBPhGfCpc5fLZBuzPvhmUx4J" +
  "KItdSieUhKhdfkOz3ZkTAfCU64/XkeTYxhWi25L06i+cr5CUo4OJ1Ai/fOxTA5O/" +
  "cR+/akEty697Tw+cGXhnHEzV41fW6v/9NMd5l4KEbjaBFjBaEFuuMOw99ViTX0s/" +
  "meF64WgEjKxSruGlrwM+3fdKTkPkoVx7YauHH5zGNoozJXit4i4+YkYIvNNY8qbE" +
  "fH4D3pRyh4n7QyisYaHJapcHr8JwtZxpjYxm6mNY1d4qCx9aGFJGUcwYRvi8JSW/" +
  "aiHSrjSBTZ3UKf+rzmHYw8uAnunKJqQKYUvxQSeYd1tXkZyGOwM6PKxpPUtd+vq+" +
  "I0jVG3HRo1aSBjkrp86ej+Y6/GI7RHR1jfekxMDduJb7Rsol5VdqVHBalIS4Wg6T" +
  "5n2UKEe60nBj4zXr/6Arc/fI8b7r3dD2STuKdwyYwGKZbzxk/E5BznL79TOLvGC5" +
  "qnadWKZdWmI+rtvVireF6GkCAwEAAQ==" +
  "-----END PUBLIC KEY-----"